import expressions from './data/expressions';

const emojiUrl = "/qq";

const arrayToObject = function (arr) {
	const result = {};
	arr.forEach(item => {
		result[item.key] = item.value;
	});
	return result;
};

export function decodeText (payload) {
	let renderDom = [];
	// 文本消息
	let temp = payload.text;
	let left = -1;
	let right = -1;
	while (temp !== '') {
		left = temp.indexOf('[');
		right = temp.indexOf(']');
		switch (left) {
			case 0:
				if (right === -1) {
					renderDom.push({
						name: 'text',
						text: temp
					});
					temp = ''
				} else {
					let _emoji = temp.slice(0, right + 1);
					let emoji = expressions.find(item => _emoji === item.title.slice(0, right + 1));
					if (emoji) {
						renderDom.push({
							name: 'img',
							src: emojiUrl + emoji.url
						});
						temp = temp.substring(right + 1)
					} else {
						renderDom.push({
							name: 'text',
							text: '['
						});
						temp = temp.slice(1)
					}
				}
				break;
			case -1:
				renderDom.push({
					name: 'text',
					text: temp
				});
				temp = '';
				break;
			default:
				renderDom.push({
					name: 'text',
					text: temp.slice(0, left)
				});
				temp = temp.substring(left);
				break
		}
	}
	return renderDom
}

export function messageSenderRole(message, groupList) {
	let memberCustomField = groupList.find(item => item.userID === message.from);
	if (!memberCustomField) {
		return '';
	}
	memberCustomField = arrayToObject(memberCustomField.memberCustomField);
	return  memberCustomField.Refund_User || memberCustomField.Role_Name || '';
}

export function messageIsCustom(message, groupList) {
	let memberCustomField = groupList.find(item => item.userID === message.from);
	if (!memberCustomField) {
		return '';
	}
	memberCustomField = arrayToObject(memberCustomField.memberCustomField);
	return  !!memberCustomField.Refund_User;
}
